export enum TargetTypeEnumFR {
  STARTUP = 'STARTUP',
  PROJET = 'PROJET',
  PME = 'PME',
  ETI = 'ETI',
  FONDS = 'FONDS',
  ENTREPRISE = 'ENTREPRISE',
  IMMOBILIER = 'IMMOBILIER',
  COOPERATIVE = 'COOPERATIVE',
  ENR = 'ENR',
  FORET = 'FORET',
  OPC = 'OPC',
  CLUB_DEAL = 'CLUB_DEAL',
  DONS = 'DONS',
}

export enum TargetTypeEnum {
  STARTUP = 'STARTUP',
  PROJET = 'PROJET',
  PME = 'PME',
  ETI = 'ETI',
  FONDS = 'FONDS',
  COMPANY = 'COMPANY',
  REAL_ESTATE = 'REAL_ESTATE',
  COOPERATIVE = 'COOPERATIVE',
  NRE = 'NRE',
  FOREST = 'FOREST',
  FUNDS = 'FUNDS',
  CLUB_DEAL = 'CLUB_DEAL',
  DONATIONS = 'DONATIONS',
}

export const getTargetTypeFromFR = (e: TargetTypeEnumFR): TargetTypeEnum => {
  switch (e) {
    case TargetTypeEnumFR.STARTUP:
      return TargetTypeEnum.STARTUP;
    case TargetTypeEnumFR.PROJET:
      return TargetTypeEnum.PROJET;
    case TargetTypeEnumFR.PME:
      return TargetTypeEnum.PME;
    case TargetTypeEnumFR.ETI:
      return TargetTypeEnum.ETI;
    case TargetTypeEnumFR.FONDS:
      return TargetTypeEnum.FONDS;
    case TargetTypeEnumFR.ENTREPRISE:
      return TargetTypeEnum.COMPANY;
    case TargetTypeEnumFR.IMMOBILIER:
      return TargetTypeEnum.REAL_ESTATE;
    case TargetTypeEnumFR.COOPERATIVE:
      return TargetTypeEnum.COOPERATIVE;
    case TargetTypeEnumFR.ENR:
      return TargetTypeEnum.NRE;
    case TargetTypeEnumFR.FORET:
      return TargetTypeEnum.FOREST;
    case TargetTypeEnumFR.OPC:
      return TargetTypeEnum.FUNDS;
    case TargetTypeEnumFR.CLUB_DEAL:
      return TargetTypeEnum.CLUB_DEAL;
    case TargetTypeEnumFR.DONS:
      return TargetTypeEnum.DONATIONS;
  }
};

export const getTargetTypeFromEN = (e: TargetTypeEnum): TargetTypeEnumFR => {
  switch (e) {
    case TargetTypeEnum.STARTUP:
      return TargetTypeEnumFR.STARTUP;
    case TargetTypeEnum.PROJET:
      return TargetTypeEnumFR.PROJET;
    case TargetTypeEnum.PME:
      return TargetTypeEnumFR.PME;
    case TargetTypeEnum.ETI:
      return TargetTypeEnumFR.ETI;
    case TargetTypeEnum.FONDS:
      return TargetTypeEnumFR.FONDS;
    case TargetTypeEnum.COMPANY:
      return TargetTypeEnumFR.ENTREPRISE;
    case TargetTypeEnum.REAL_ESTATE:
      return TargetTypeEnumFR.IMMOBILIER;
    case TargetTypeEnum.COOPERATIVE:
      return TargetTypeEnumFR.COOPERATIVE;
    case TargetTypeEnum.NRE:
      return TargetTypeEnumFR.ENR;
    case TargetTypeEnum.FOREST:
      return TargetTypeEnumFR.FORET;
    case TargetTypeEnum.FUNDS:
      return TargetTypeEnumFR.OPC;
    case TargetTypeEnum.CLUB_DEAL:
      return TargetTypeEnumFR.CLUB_DEAL;
    case TargetTypeEnum.DONATIONS:
      return TargetTypeEnumFR.DONS;
  }
};

export const getTargetTypeArrayFromEN = (a: TargetTypeEnum[]): TargetTypeEnumFR[] => {
  return a.map(e => getTargetTypeFromEN(e));
};
